import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getFormattedAgentList } from "../../pages/AquaZone/aquahelper";
import {
  getFormattedLwwTicketData,
  getFormattedProductList,
} from "../../pages/LwwTickets/lwwtickethelper";
import { downloadReport, getAgentList } from "../../services/aquaServices";
import {
  getAvailableCount,
  getLwwTickets,
} from "../../services/lwwTicketServices";
import { getFormattedDate } from "../getFormattedDate";
import { ToastMessage } from "../ToastMessage";
import LwwTicketTable from "./LwwTicketTable";
import TicketSubHeader from "./TicketSubHeader";
import {
  fetchAllActiveProducts,
  fetchAllProducts,
} from "../../services/productService";
import { Colors } from "../../config/Constants";
import styled from "styled-components";
import Search from "../Search";
import Button from "../Button";
import { useLoadContext } from "../../contexts/LoadContext";
import Modal from "../Modal";
const LIMIT = 10;

const downloadIcon = require("../../assets/images/download-icon.png");
const filterIcon = require("../../assets/images/filter_icon.png");
const LWW_FILTER = [
  { label: "All", value: "all" },
  { label: "Product", value: "product" },
];

const LWW_FILTER_DATE_TYPE = [
  { label: "Visit Date", value: "visiting_date" },
  { label: "Booking Date", value: "date" },
];

const LWW_FILTER_DATE = [
  { label: "Today", value: "today" },
  { label: "Yesterday", value: "yesterday" },
  { label: "Week", value: "week" },
  { label: "Month", value: "month" },
  { label: "Custom Date", value: "custom" },
];

const LwwTicketBody = () => {
  const [reportDate, setReportDate] = useState<Date | null | any>(new Date());
  // const [toDate, setToDate] = useState(new Date());
  const [selectedFilter, setFilter] = useState(0);
  const [productList, setProductList] = useState([]);
  const [ticketData, setTicketData] = useState([]);
  const [product, setProduct] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuerySkipId, setSearchQuerySkipId] = useState("");
  const [dateTypeFilter, setDateTypeFilter] = useState(0);
  const [dateFilter, setDateFilter] = useState(0);
  const [fromDate, setFromDate] = useState<Date | null | any>();
  const [toDate, setToDate] = useState<Date | null | any>();
  const [totalProducts, setTotalProducts] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sizeFilter, setSizeFilter] = useState(window.innerWidth > 769);
  const [filterVisible, setFilterVisible] = useState(window.innerWidth > 769);
  let today = new Date();
  const { setLoader } = useLoadContext();
  const [availableCount, setAvailableCount] = useState([]);
  const [countPopup, setCountPopup] = useState(false);

  const fetchLWWData = async (
    productId: string,
    dateFilter: any,
    filter: any,
    dateTypeFilter: any,
    searchText: string,
    page: number,
    fromDate: string,
    toDate: string,
    searchTextSkipId: any
  ) => {
    let filterType = LWW_FILTER_DATE_TYPE[dateTypeFilter]?.value;
    let filterDate = LWW_FILTER_DATE[dateFilter]?.value;
    if (LWW_FILTER[filter]?.value === "product" && !product) {
      toast.warn("Please select product");
    } else {
      setLoader(true);
      let res = await getLwwTickets(
        productId,
        filterType,
        searchText,
        filterDate,
        fromDate,
        toDate,
        page,
        LIMIT,
        searchTextSkipId
      );
      setTotalProducts(res.data.count);
      setTicketData(getFormattedLwwTicketData(res?.data?.data));
      setLoader(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const isDesktop = window.innerWidth > 769;
      setSizeFilter(isDesktop);
      setFilterVisible(isDesktop);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleFilter = (index: any) => {
    if (index === 0) {
      setProduct("");
    }
    setFilter(index);
  };

  const handleTypeFilter = (index: any) => {
    setDateTypeFilter(index);
  };

  const handleFilterDate = (index: any) => {
    setDateFilter(index);
  };

  const handleClearFilter = () => {
    setFilter(0);
    setProduct("");
  };

  const handleClearFilterDate = () => {
    setDateFilter(0);
  };

  const handleClearFilterType = () => {
    setDateTypeFilter(0);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchLWWData(
      product,
      dateFilter,
      selectedFilter,
      dateTypeFilter,
      searchQuery,
      page,
      fromDate,
      toDate,
      searchQuerySkipId
    );
  };

  useEffect(() => {
    fetchParks();
    fetchCounts();
    fetchLWWData("", 0, 0, 0, "", currentPage, "", "", "");
  }, []);

  const fetchParks = async () => {
    try {
      const productId = process.env.REACT_APP_PRODUCT_ID;
      let { data } = await fetchAllActiveProducts("winter", productId);
      if (data.code === 200) {
        let formattedData = getFormattedProductList(
          data.data,
          "Select Product"
        );
        setProductList(formattedData);
      }
    } catch (error) {
      console.error("Error fetching parks:", error);
    }
  };

  const fetchCounts = async () => {
    try {
      let { data } = await getAvailableCount();
      console.log(data);

      //   if (data.code === 200) {
      setAvailableCount(data?.data?.qrInfo);
      //   }
    } catch (error) {
      console.error("Error fetching parks:", error);
    }
  };

  const handleProductSelect = (e: any) => {
    setProduct(e?.target.value);
  };

  const handleSetReportDate = (
    startDate: string | null,
    endDate: string | null
  ) => {
    console.log("Start Date:", startDate);
    console.log("End Date:", endDate);
    if (dateFilter === 4) {
      if (startDate && endDate) {
        setFromDate(startDate);
        setToDate(endDate);
        fetchLWWData(
          product,
          dateFilter,
          selectedFilter,
          dateTypeFilter,
          searchQuery,
          currentPage,
          startDate,
          endDate,
          searchQuerySkipId
        );
      } else {
        toast.warn("Please provide both start and end dates");
      }
    } else {
      setFromDate("");
      setToDate("");
      fetchLWWData(
        product,
        dateFilter,
        selectedFilter,
        dateTypeFilter,
        searchQuery,
        currentPage,
        "",
        "",
        searchQuerySkipId
      );
    }
  };

  const handleSearch = (value: any) => {
    setCurrentPage(1);
    setSearchQuery(value);
    fetchLWWData(
      product,
      dateFilter,
      selectedFilter,
      dateTypeFilter,
      value,
      currentPage,
      fromDate,
      toDate,
      searchQuerySkipId
    ); // NEED TO REVISIT
  };

  const handleSearchSkip = (value: any) => {
    setCurrentPage(1);
    setSearchQuerySkipId(value);
    fetchLWWData(
      product,
      dateFilter,
      selectedFilter,
      dateTypeFilter,
      searchQuery,
      currentPage,
      fromDate,
      toDate,
      value
    ); // NEED TO REVISIT
  };

  const handleSaveFilter = () => {
    fetchLWWData(
      product,
      dateFilter,
      selectedFilter,
      dateTypeFilter,
      searchQuery,
      currentPage,
      fromDate,
      toDate,
      searchQuerySkipId
    ); // NEED TO REVISIT
  };

  const handleFilterClick = () => {
    setFilterVisible(!filterVisible);
  };

  const handleDownload = async () => {
    let date = getFormattedDate(reportDate, "YYYY-MM-DD");
    let filterType = LWW_FILTER[selectedFilter].value;
    if (LWW_FILTER[selectedFilter].value === "product" && !product) {
      toast.warn("Please select Product");
    } else {
      try {
        const response = await downloadReport(
          product,
          date,
          filterType,
          searchQuery
        );
        const outputFilename = `transactions.xlsx`;
        const url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        console.log(url);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", outputFilename);
        document.body.appendChild(link);
        link.click();
      } catch (error: any) {
        if (navigator.onLine) {
          toast.error(error.message, { hideProgressBar: true });
        } else {
          toast.error(
            <ToastMessage
              message="You're offline now"
              subMessage="Oops! Internet is disconnected."
            />,
            {
              hideProgressBar: true,
            }
          );
        }
      }
    }
  };

  return (
    <MainContainer>
      <StyledManageParkHeader>
        <TitleWrapper>
          <StyledPageHeader>{"Lusail Winter Wonderland"}</StyledPageHeader>
          <IconWrapper onClick={handleFilterClick}>
            <img src={filterIcon} alt="Filter Icon" width="24" height="24" />
          </IconWrapper>
        </TitleWrapper>
        {filterVisible && !sizeFilter && (
          <TicketSubHeader
            today={today}
            reportDate={reportDate}
            onSetReportDate={handleSetReportDate}
            onFilterSelect={handleFilter}
            onFilterSelectDate={handleFilterDate}
            onFilterType={handleTypeFilter}
            selectedFilter={selectedFilter}
            dateFilter={dateFilter}
            dateTypefilter={dateTypeFilter}
            filterEntities={LWW_FILTER}
            filterTypeEntities={LWW_FILTER_DATE_TYPE}
            filterDateEntities={LWW_FILTER_DATE}
            onClearFilter={handleClearFilter}
            onClearFilterDate={handleClearFilterDate}
            onClearFilterType={handleClearFilterType}
            productList={productList}
            onAgentSelect={handleProductSelect}
            searchQuery={searchQuery}
            onSearch={handleSearch}
            onSaveFilter={handleSaveFilter}
            onDownload={handleDownload}
            agent={product}
          />
        )}
        <MobileSearchContainer>
          <Search
            placeholder="Search by skipcash id"
            onChange={handleSearchSkip}
            value={searchQuerySkipId}
            width={"320px"}
          />
          <Search
            placeholder="Search by name, email, ticket id"
            onChange={handleSearch}
            value={searchQuery}
            width={"320px"}
          />
        </MobileSearchContainer>
        <Button
          label="Available Count"
          variant="filled"
          color={Colors.solidRed}
          size="medium"
          // isRounded={true}
          onClick={() => setCountPopup(true)}
          // endIcon={downloadIcon}
          width="10rem"
        />
      </StyledManageParkHeader>
      {filterVisible && sizeFilter && (
        <TicketSubHeader
          today={today}
          reportDate={reportDate}
          onSetReportDate={handleSetReportDate}
          onFilterSelect={handleFilter}
          onFilterSelectDate={handleFilterDate}
          onFilterType={handleTypeFilter}
          selectedFilter={selectedFilter}
          dateFilter={dateFilter}
          dateTypefilter={dateTypeFilter}
          filterEntities={LWW_FILTER}
          filterTypeEntities={LWW_FILTER_DATE_TYPE}
          filterDateEntities={LWW_FILTER_DATE}
          onClearFilter={handleClearFilter}
          onClearFilterDate={handleClearFilterDate}
          onClearFilterType={handleClearFilterType}
          productList={productList}
          onAgentSelect={handleProductSelect}
          searchQuery={searchQuery}
          onSearch={handleSearch}
          onSaveFilter={handleSaveFilter}
          onDownload={handleDownload}
          agent={product}
        />
      )}
      <LwwTicketTable
        data={ticketData}
        isTableDataLoading={false}
        totalProducts={totalProducts}
        limit={LIMIT}
        onPageChange={handlePageChange}
        currentPage={currentPage}
      />
     {countPopup && <Modal variant="none" setOpenOrClose={() => setCountPopup(false)} width="400px">
        <ModalContent>
          <Title>Available QR Count</Title>

          {availableCount?.map((ac: any) => (
            <Item key={ac?.product}>
              <ProductName>{ac?.product}</ProductName>
              <ItemMeta>
                <div>Available QR Count : {ac?.availableQrCount}</div>
                <div>Type : {ac?.productType || "NA"}</div>
              </ItemMeta>
            </Item>
          ))}

          <Footer>
            <Button
              label="Close"
              variant="filled"
              color={Colors.solidRed}
              size="medium"
              onClick={() => setCountPopup(false)}
              width="10rem"
            />
          </Footer>
        </ModalContent>
      </Modal>}
    </MainContainer>
  );
};

export default LwwTicketBody;

// const Footer = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   margin-top: 1rem;
// `;

const ModalContent = styled.div`
  padding: 1rem 2rem;
  max-height: 500px;
  overflow: auto;
`;

const Title = styled.div`
  text-align: center;
  padding: 0.5rem 0;
  font-size: 1.2rem;
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 400;
  padding: 1rem 0;
`;

const ProductName = styled.div``;

const ItemMeta = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: grey;
`;

const Footer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
`;

const MainContainer = styled.div`
  @media only screen and (max-width: 1024px) {
    margin-inline: 1rem;
    margin-top: 0.5rem;
  }
`;

const ActionContainer = styled.div`
  display: flex;
  gap: 3rem;
  align-items: center;
  padding-top: 0.5rem;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
    padding-top: 2rem;
  }
`;

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  /* @media only screen and (max-width: 768px) {
    display: none;
  } */
`;

const StyledManageParkHeader = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  padding-bottom: 1rem;
  align-items: center;
  @media only screen and (max-width: 768px) {
    display: block;
    align-items: flex-start;
    padding-bottom: 0rem;
    flex-direction: column;
  }
`;

const ManageParkHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
    flex: 1;
    padding: 1.5rem;
  }
`;

const IconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 2rem;
  @media only screen and (min-width: 768px) {
    display: none;
  }
`;

const MobileSearchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  @media only screen and (max-width: 768px) {
    width: 100%;
    flex-direction: column;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%; // Ensures the container takes full width

  @media only screen and (max-width: 768px) {
    flex-direction: row;
    margin-bottom: 1rem;
  }
`;
